export const buildImageStylesheet = (builder, device, cta, element) => {
    let options = { ...element.options };

    let boxShadow;

    if (options["box-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["box-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["box-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (element.options["box-shadow-horizontal-distance"]
          ? `${element.options["box-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-vertical-distance"]
          ? `${element.options["box-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-blur-radius"]
          ? `${element.options["box-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-spread-radius"]
          ? `${element.options["box-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-color"]
          ? element.options["box-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    const controlStyle = element.options["control-style"] ? element.options["control-style"] : "width";

    // prettier-ignore
    const desktopStyles =
`#cta_${cta.id} .cf-element[data-element-id="${element.id}"] img {
  vertical-align: middle !important;
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
  ${controlStyle == "width" && ["image"].includes(element.element_type) && element.options['image-width'] ? `width: ${element.options['image-width']}px !important;` : ''}
  ${controlStyle == "height" && ["image"].includes(element.element_type) && element.options['image-height'] ? `height: ${element.options['image-height']}px !important;` : ''}
}
`;

  const controlStyleMobile = element.options["control-style-mobile"]
    ? element.options["control-style-mobile"]
    : element.options["control-style"]
      ? element.options["control-style"]
      : "width";

    // prettier-ignore
    const mobileStyles =
`/* mobile styles */
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] img {
  ${controlStyleMobile == "width" ? 'height: initial !important;' : ''}
  ${controlStyleMobile == "height" ? 'width: initial !important;' : ''}
  ${controlStyleMobile == "width" && ["image"].includes(element.element_type) && element.options['image-width-mobile'] ? `width: ${element.options['image-width-mobile']}px !important;` : ''}
  ${controlStyleMobile == "height" && ["image"].includes(element.element_type) && element.options['image-height-mobile'] ? `height: ${element.options['image-height-mobile']}px !important;` : ''}
}`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
